module.exports = __webpack_public_path__ + "media/components/Application/FormTags/Categories/22-54806b9e3378aa3e1fb4f4118e565bd2.png";